import { formValueSelector } from 'redux-form';
import * as types from './types';
import * as studentInfoActions from './studentinfo/actions';
import { loading } from 'State/actions';
import { FieldEnum } from 'Common/FieldEnum';
import {
  createToast,
  toastType,
  toastErrorFromCatch,
} from 'Common/ToastHelper';
import { ACCOUNT_SETUP_FORM_NAME } from 'Common/FormEnum';
import { resetDirty } from 'State/dirtyTracking/actions';

export const setIsNewStudent = (value) => {
  return {
    type: types.ACCOUNT_SETUP_SET_IS_NEW_STUDENT,
    payload: value,
  };
};

export const setShowEditModal = (value) => {
  return {
    type: types.ACCOUNT_SETUP_SET_SHOW_EDIT_MODAL,
    payload: value,
  };
};

export const getAccountSetup = (pageObj) => {
  return (dispatch, getState, MPWWebApi) => {
    const {
      AccountSetupState: { studentFilter },
    } = getState();
    pageObj = { ...studentFilter, ...pageObj };
    dispatch(saveStudentFilters(pageObj));
    dispatch(
      getStudentDetails(
        types.ACCOUNT_SETUP_GET_STUDENTS,
        types.ACCOUNT_SETUP_GET_STUDENTS_ERROR,
        pageObj,
        true
      )
    );
  };
};

export const getStudentInfoAction = (pageObj) => {
  return (dispatch, getState, MPWWebApi) => {
    const {
      AccountSetupState: { studentInfoFilter, studentFilter },
    } = getState();
    pageObj = { ...studentInfoFilter, ...studentFilter, ...pageObj };
    dispatch(saveStudentInfoFilters(pageObj));
    dispatch(
      getStudentDetails(
        types.ACCOUNT_SETUP_GET_STUDENTINFO,
        types.ACCOUNT_SETUP_GET_STUDENTINFO_ERROR,
        pageObj,
        false
      )
    );
  };
};

export const postStudentAllergen = (allergen) => {
  return (dispatch, getState, MPWWebApi) => {
    MPWWebApi.postGenericInsertUpdate('allergenstudent', allergen)
      .then((response) => {
        dispatch({
          type: types.ACCOUNT_SETUP_POST_ALLERGENS,
          payload: response.data,
          //status: status,
        });
        if (response.data.Data !== '') {
          createToast(toastType.success, 'Success', response.data.Data, true);
        }
      })

      .catch((error) => {
        dispatch({
          type: types.ACCOUNT_SETUP_POST_ALLERGENS_ERROR,
          payload: error.response,
        });
      });
  };
};

export const getStudentAllergens = (id) => {
  return (dispatch, getState, MPWWebApi) => {
    MPWWebApi.getGeneric(`student/allergen/${id}`)
      .then((response) => {
        dispatch({
          type: types.ACCOUNT_SETUP_GET_ALLERGENS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: types.ACCOUNT_SETUP_GET_ALLERGENS_ERROR,
          payload: error.response,
        });
      });
  };
};

export const saveStudentInfoAction = (
  obj,
  studentImage,
  deleteImage,
  refreshGrid
) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ACCOUNT_SETUP_STUDENT_SAVING, true));

    const {
      AccountSetupState: { isNewStudent },
    } = getState();

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `student/write`,
        obj
      );
      dispatch({
        type: types.ACCOUNT_SETUP_SAVE_STUDENTINFO,
        payload: response.data,
      });
      dispatch({
        type: types.ACCOUNT_SETUP_UPDATE_STUDENTINFO,
        payload: {
          Data: {
            ...response.data.Data,
            TotalPages: obj.TotalPages,
            TotalRowCount: obj.TotalRowCount,
          },
        },
      });

      const { IdSeed } = response.data.Data;

      if (studentImage) {
        await studentInfoActions
          .postStudentPicture(studentImage, IdSeed, MPWWebApi)
          .catch((error) => {
            dispatch(studentInfoActions.studentPictureError(error));
            toastErrorFromCatch(error, 'Unable to save Student Picture');
          });
      } else if (deleteImage) {
        dispatch(studentInfoActions.deleteStudentPicture(IdSeed));
      }

      if (isNewStudent) {
        if (refreshGrid) {
          dispatch(getAccountSetup({}));
        }

        dispatch(setShowEditModal(false));
      }

      createToast(
        toastType.success,
        'Success',
        'Student information saved successfully.',
        true
      );

      //TODO: Reset dirty
      dispatch(resetDirty());
    } catch (error) {
      dispatch({
        type: types.ACCOUNT_SETUP_SAVE_STUDENTINFO_ERROR,
        payload: error.response,
      });

      toastErrorFromCatch(error, 'Unable to save student details');
    }

    dispatch(loading(types.ACCOUNT_SETUP_STUDENT_SAVING, false));
  };
};

export const getServingNumber = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      const response = await MPWWebApi.getGeneric('student/GenerateServingNum');

      dispatch({
        type: types.ACCOUNT_SETUP_GET_SERVINGNUMBER,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: types.ACCOUNT_SETUP_GET_SERVINGNUMBER_ERROR,
        payload: error.response,
      });
    }
  };
};

export const loadingGridAction = (value) => {
  return {
    type: types.ACCOUNT_SETUP_GRID_LOADING,
    payload: value,
  };
};

export const updateAllergenData = (item) => {
  return {
    type: types.ACCOUNT_SETUP_ALLERGEN_DATA_CHECK,
    payload: item,
  };
};

export const checkAll = (checkAll, currentRows) => {
  return {
    type: types.ACCOUNT_SETUP_ALLERGEN_CHECKALL,
    payload: { checkAll, currentRows },
  };
};

export const clearServingNumber = () => {
  return {
    type: types.ACCOUNT_SETUP_CLEAR_SERVINGNUMBER,
    payload: undefined,
  };
};

export const clearMealHistory = () => {
  return {
    type: types.ACCOUNT_SETUP_CLEAR_MEALHISTORY,
    payload: undefined,
  };
};

export const saveStudentFilters = (obj) => {
  return (dispatch, getState, MPWWebApi) => {
    const {
      AccountSetupState: { studentFilter },
    } = getState();
    obj = { ...studentFilter, ...obj };
    dispatch({
      type: types.ACCOUNT_SETUP_STUDENT_FILTER,
      payload: obj,
    });
  };
};

export const saveStudentInfoFilters = (obj) => {
  return (dispatch, getState, MPWWebApi) => {
    const {
      AccountSetupState: { studentInfoFilter },
    } = getState();
    obj = { ...studentInfoFilter, ...obj };
    dispatch({
      type: types.ACCOUNT_SETUP_STUDENTINFO_FILTER,
      payload: obj,
    });
  };
};

export const setValidStatusFieldChanged = () => {
  return {
    type: types.ACCOUNT_SETUP_SET_VALIDSTATUSFIELDCHANGED,
  };
};

export const getValidStatusFromForm = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ACCOUNT_SETUP_VALID_STATUS_LOADING, true));

    //lives here because needs the entire state for formValueSelector
    const formValues = formValueSelector(ACCOUNT_SETUP_FORM_NAME)(
      getState(),
      FieldEnum.Id,
      FieldEnum.IdSeed,
      FieldEnum.SiteId,
      FieldEnum.BillingAcc
    );

    dispatch(
      getValidStatusFromApi(
        formValues.id,
        formValues.idSeed,
        formValues.siteId,
        formValues.billingAcc
      )
    );
  };
};

export const getValidStatusFromApi = (id, idSeed, siteId, billingAcc) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ACCOUNT_SETUP_VALID_STATUS_LOADING, true));

    const model = { id, idSeed, siteId, billingAcc };
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `student/ValidStatus`,
        model
      );
      dispatch({
        type: types.ACCOUNT_SETUP_GET_VALID_STATUS,
        payload: response.data.Data,
      });
    } catch (error) {}

    dispatch(loading(types.ACCOUNT_SETUP_VALID_STATUS_LOADING, false));
  };
};

export const getProhibitedItems = (studentIdSeed) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ACCOUNT_SETUP_PROHIBITED_ITEMS_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `student/${studentIdSeed}/prohibiteditems`
      );
      dispatch({
        type: types.ACCOUNT_SETUP_GET_PROHIBITED_ITEMS,
        payload: response.data.Data,
      });
    } catch (error) {}

    dispatch(loading(types.ACCOUNT_SETUP_PROHIBITED_ITEMS_LOADING, false));
  };
};

export const updateProhibitedItem = (item) => {
  return {
    type: types.ACCOUNT_SETUP_UPDATE_PROHIBITED_ITEM,
    payload: item,
  };
};

export const checkAllProhibitedItems = (isProhibited, items) => {
  return {
    type: types.ACCOUNT_SETUP_CHECK_ALL_PROHIBITED_ITEMS,
    payload: { items, isProhibited },
  };
};

export const saveProhibitedItems = (studentIdSeed) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ACCOUNT_SETUP_PROHIBITED_ITEMS_SAVING, true));

    const {
      AccountSetupState: { prohibitedItemsData },
    } = getState();
    const servedItemIds = prohibitedItemsData
      .filter((i) => i.IsProhibited)
      .map((i) => i.ItemId);

    const data = {
      studentIdSeed,
      servedItemIds,
    };

    try {
      await MPWWebApi.postGenericInsertUpdate(
        `student/${studentIdSeed}/prohibiteditems`,
        data
      );
      dispatch({
        type: types.ACCOUNT_SETUP_PROHIBITED_ITEMS_SAVE_SUCCESS,
      });
    } catch (error) {
      dispatch({
        type: types.ACCOUNT_SETUP_PROHIBITED_ITEMS_SAVE_ERROR,
        payload: error,
      });
    }

    dispatch(loading(types.ACCOUNT_SETUP_PROHIBITED_ITEMS_SAVING, false));
  };
};

export const clearProhibitedItemsError = () => {
  return {
    type: types.ACCOUNT_SETUP_PROHIBITED_ITEMS_CLEAR_ERROR,
  };
};

export const resetProhibitedItems = () => {
  return {
    type: types.ACCOUNT_SETUP_PROHIBITED_ITEMS_RESET,
  };
};

export const rowIndexUpdate = (rowIndex) => {
  return {
    type: types.ACCOUNT_SETUP_ROWINDEX,
    payload: rowIndex,
  };
};

const getStudentDetails = (successType, failType, pageObj, showLoading) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      showLoading && dispatch(loadingGridAction(true));
      !showLoading &&
        dispatch(loading(types.ACCOUNT_SETUP_STUDENTINFO_LOADING, true));
      const response = await MPWWebApi.postGenericInsertUpdate(
        'student',
        pageObj
      );
      dispatch({
        type: successType,
        payload: response.data,
      });

      const finalData = !showLoading && response.data.Data.Result[0];
      !showLoading &&
        dispatch(
          getValidStatusFromApi(
            finalData.Id,
            finalData.IdSeed,
            finalData.SiteId,
            finalData.BillingAcc
          )
        );
      showLoading && dispatch(loadingGridAction(false));
      !showLoading &&
        dispatch(loading(types.ACCOUNT_SETUP_STUDENTINFO_LOADING, false));

      // If we are loading a student info into the modal, try to load the picture
      if (types.ACCOUNT_SETUP_GET_STUDENTINFO === successType)
        dispatch(studentInfoActions.getStudentPicture());
    } catch (error) {
      dispatch({
        type: failType,
        payload: error.response,
      });
      showLoading && dispatch(loadingGridAction(false));
      !showLoading &&
        dispatch(loading(types.ACCOUNT_SETUP_STUDENTINFO_LOADING, false));

      createToast(
        toastType.error,
        'Error',
        'Unable to save student details',
        true
      );
    }
  };
};

export const postStudentNumber = (newNumber) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ACCOUNT_SETUP_CHANGE_STUDENT_NUMBER_LOADING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Student/UpdateStudentNumber',
        newNumber
      );
      dispatch({
        type: types.ACCOUNT_SETUP_POST_STUDENTNUMBER,
        payload: response.data,
      });
      dispatch(getAccountSetup({}));
      createToast(
        toastType.success,
        'Success',
        'Student Number changed successfully',
        true
      );
    } catch (error) {
      dispatch({
        type: types.ACCOUNT_SETUP_POST_STUDENTNUMBER_ERROR,
        payload: error.response,
      });
      createToast(
        toastType.error,
        error.response.data.Errors[0].Title,
        error.response.data.Errors[0].Message,
        true
      );
    }

    dispatch(loading(types.ACCOUNT_SETUP_CHANGE_STUDENT_NUMBER_LOADING, false));
  };
};

export const clearChangeStudentNumber = () => {
  return {
    type: types.ACCOUNT_SETUP_CLEAR_CHANGE_STUDENT_NUMBER,
  };
};

export const deleteStudent = (idSeed) => {
  return (dispatch, getState, MPWWebApi) => {
    MPWWebApi.postGenericDelete(`student`, idSeed)
      .then((response) => {
        dispatch({
          type: types.ACCOUNT_SETUP_DELETE_STUDENT,
          payload: response.data,
        });
        createToast(
          toastType.success,
          'Success',
          'Student deleted successfully',
          true
        );
        dispatch(getAccountSetup({}));
      })
      .catch((error) => {
        dispatch({
          type: types.ACCOUNT_SETUP_DELETE_STUDENT_ERROR,
          payload: error.response,
        });

        createToast(toastType.error, 'Error', 'Unable to delete Student', true);
      });
  };
};

export const getTransactionHistory = (
  pageNumber,
  pageSize,
  sortOptions,
  filterOptions,
  idSeed
) => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ACCOUNT_SETUP_MEALHISTORY_LOADING, true));

    const model = {
      PageNumber: pageNumber,
      PageSize: pageSize,
      SortColumn: sortOptions,
      Filter: filterOptions,
      IdSeed: idSeed,
    };

    MPWWebApi.postGenericInsertUpdate(
      `student/transactionhistorywithpaging`,
      model
    )
      .then((response) => {
        dispatch({
          type: types.ACCOUNT_SETUP_GET_TRANSACTIONHISTORY,
          payload: response.data.Data,
        });
        dispatch(loading(types.ACCOUNT_SETUP_MEALHISTORY_LOADING, false));
      })
      .catch((error) => {
        dispatch({
          type: types.ACCOUNT_SETUP_GET_TRANSACTIONHISTORY_ERROR,
          payload: error.response,
        });
        dispatch(loading(types.ACCOUNT_SETUP_MEALHISTORY_LOADING, false));
      });
  };
};

export const setSelectedTab = (value) => ({
  type: types.ACCOUNT_SETUP_SET_SELECTED_TAB,
  payload: value,
});

export const clearStudentInfo = () => ({
  type: types.ACCOUNT_SETUP_CLEAR_STUDENTINFO,
  payload: null,
});

export const getBillingAccountStudents = (id) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(`student/GetBillingAccountStudents/${id}`);

      dispatch({
        type: types.ACCOUNT_SETUP_GET_BILLING_ACCOUNT_STUDENTS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: types.ACCOUNT_SETUP_GET_BILLING_ACCOUNT_STUDENTS_ERROR,
        payload: error.response,
      });
    }
  };
};

export const clearBillingAccountStudents = () =>({
  type: types.ACCOUNT_SETUP_CLEAR_BILLING_ACCOUNT_STUDENTS,
  payload: null
})



// WEBPACK FOOTER //
// ./src/pages/accountsetup/state/actions.js